module.exports = __webpack_public_path__ + "media/images/收费员-4cf92c78784d84339bf7eaace53cd8a0.png";